import Vue from 'vue'
import Router from 'vue-router'
import UserFormRouter from './adminRoutes/userform'
import CaseTypeRouter from './adminRoutes/cases'
import FormTemplateRouter from './adminRoutes/formtemplate'
import ContactsRouter from './adminRoutes/contacts'
import UsersRouter from './adminRoutes/users'
import SuperUserRouter from './adminRoutes/superuser'
import ReportsRouter from './adminRoutes/reports'
import NotFound from './notfound'
import Login from '@/components/admin/Login'
import AppHome from '@/components/admin/Home'
import OrgBranding from '@/components/admin/org/OrgBranding'
import OrgFieldtype from '@/components/admin/org/OrgFieldtype'
import OrgCases from '@/components/admin/org/OrgCases'
import OrgCommunicationDefaults from '@/components/admin/org/OrgCommunicationDefaults'
import OrgCommunicationAutoReply from '@/components/admin/org/OrgCommunicationAutoReply'
import OrgContactInfo from '@/components/admin/org/OrgContactInfo'
import OrgRouter from '@/components/admin/org/OrgRouter'
import OrgGroups from '@/components/admin/org/OrgGroups'
import OrgRoles from '@/components/admin/org/OrgRoles'
import OrgEmailBounces from '@/components/admin/org/OrgEmailBounces'
import OrgSmsBounces from '@/components/admin/org/OrgSmsBounces'
import OrgNews from '@/components/admin/org/OrgNews'
import OrgWebhooks from '@/components/admin/org/OrgWebhooks'
import OrgWebhookLog from '@/components/admin/org/OrgWebhooks'
import UserList from '@/components/admin/users/UserList'
import User from '@/components/admin/users/User'
import auth from './auth'
import OrgUnknownSMS from '../components/admin/org/OrgUnknownSMS.vue'

Vue.use(Router)

const genericRoutes = [
  {
    path: '/admin/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/admin/org/',
    component: OrgRouter,
    beforeEnter: auth.isAdmin,
    children: [
      {
        path: 'branding',
        name: 'OrgBranding',
        component: OrgBranding
      },
      {
        path: 'news',
        name: 'OrgNews',
        component: OrgNews
      },
      {
        path: 'news/:id?',
        name: 'OrgSelectedNews',
        component: OrgNews
      },
      {
        path: 'detail_headers',
        name: 'OrgContactInfo',
        component: OrgContactInfo
      },
      {
        path: 'users',
        name: 'OrgUsers',
        component: UserList
      },
      {
        path: 'users/:id?',
        name: 'OrgEditUser',
        component: User
      },
      {
        path: 'webhooks',
        name: 'OrgWebhooks',
        component: OrgWebhooks
      },
      {
        path: 'webhooks/:id?',
        name: 'OrgSelectedWebhook',
        component: OrgWebhooks
      },
      {
        path: 'roles',
        name: 'OrgRoles',
        component: OrgRoles
      },
      {
        path: 'roles/:id?',
        name: 'OrgSelectedRoles',
        component: OrgRoles
      },
      {
        path: 'comm/defaults',
        name: 'OrgCommunicationDefaults',
        component: OrgCommunicationDefaults
      },
      {
        path: 'comm/autoreply',
        name: 'OrgCommunicationAutoReply',
        component: OrgCommunicationAutoReply
      },
      {
        path: 'users/:id?',
        name: 'User',
        component: UserList
      },
      {
        path: 'fieldtype',
        name: 'OrgFieldtype',
        component: OrgFieldtype
      },
      {
        path: 'bounces/email',
        name: 'OrgEmailBounces',
        component: OrgEmailBounces
      },
      {
        path: 'bounces/sms',
        name: 'OrgSmsBounces',
        component: OrgSmsBounces
      },
      {
        path: 'fieldtype/:id?',
        name: 'OrgSelectedFieldtype',
        component: OrgFieldtype
      },
      {
        path: 'casetypes',
        name: 'OrgCaseType',
        component: OrgCases
      },
      {
        path: 'casetypes/:id?',
        name: 'OrgSelectedCaseType',
        component: OrgCases
      },
      {
        path: 'groups',
        name: 'OrgGroups',
        component: OrgGroups
      },
      {
        path: 'groups/:id?',
        name: 'OrgSelectedGroups',
        component: OrgGroups
      },
      {
        path: 'unknownsms',
        name: 'OrgUnknownSMS',
        component: OrgUnknownSMS
      }
    ]
  },
  {
    path: '/admin/',
    name: 'AppHome',
    component: AppHome,
    beforeEnter: auth.ifAuthenticated
  }
]

var routes = genericRoutes.concat(ContactsRouter)
routes = routes.concat(UserFormRouter)
routes = routes.concat(CaseTypeRouter)
routes = routes.concat(FormTemplateRouter)
routes = routes.concat(UsersRouter)
routes = routes.concat(SuperUserRouter)
routes = routes.concat(ReportsRouter)
routes = routes.concat(NotFound)
export default new Router({
  mode: 'history',
  routes
})
